// src/components/Player.js

import { FiChevronDown, FiFilm } from 'react-icons/fi';

// Add 'selectedSeason' to the component's props
export default function Player({ embedUrl, episodes, selectedSeason, selectedEpisode, handlePrevEpisode, handleNextEpisode, isEpisodeReleased }) {
  const showNav = episodes.length > 1;
  const isFirstEpisode = selectedEpisode <= 1 || !episodes.find(ep => ep.episode_number === selectedEpisode - 1 && isEpisodeReleased(ep.air_date));
  const isLastEpisode = selectedEpisode >= episodes.length || !episodes.find(ep => ep.episode_number === selectedEpisode + 1 && isEpisodeReleased(ep.air_date));

  // Find the current episode's data to get the title
  const currentEpisode = episodes.find(ep => ep.episode_number === selectedEpisode);
  const episodeTitle = currentEpisode ? currentEpisode.name : 'Loading...';

  // Construct the new display string with "Episode" instead of "E"
  const episodeDisplayText = `Season ${selectedSeason} - Episode ${selectedEpisode} - ${episodeTitle}`;

  return (
    <div className="aspect-w-16 aspect-h-9 bg-gray-800 my-0 sm:my-4 mx-0 sm:mx-4 md:mx-6 rounded-none sm:rounded-lg overflow-hidden border-0 sm:border border-gray-700">
      {embedUrl ? (
        <iframe
          src={embedUrl}
          className="w-full h-48 sm:h-64 md:h-96 lg:h-[500px]"
          allowFullScreen
          frameBorder="0"
          loading="lazy"
          sandbox="allow-same-origin allow-scripts allow-orientation-lock allow-presentation"
          referrerPolicy="no-referrer"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture fullscreen"
        ></iframe>
      ) : (
        <div className="w-full h-48 sm:h-64 md:h-96 lg:h-[500px] flex items-center justify-center bg-gradient-to-br from-gray-800 to-gray-900">
          <div className="text-white flex flex-col items-center">
            <div className="animate-pulse">
              <FiFilm className="w-8 h-8 sm:w-12 sm:h-12 mb-2 text-gray-500" />
            </div>
            <p className="text-sm sm:text-base text-gray-400">Loading player...</p>
          </div>
        </div>
      )}

      {showNav && (
        <div className="flex items-center justify-between pt-2 pb-2">
          <button onClick={handlePrevEpisode} disabled={isFirstEpisode} className="flex-shrink-0 flex items-center gap-2 px-3 py-2 bg-gray-700 hover:bg-gray-600 disabled:bg-gray-800 disabled:text-gray-500 text-white rounded-lg text-sm font-medium transition-all duration-200 disabled:cursor-not-allowed">
            <FiChevronDown className="rotate-90 text-sm" /> Previous
          </button>
                    
          {/* --- UPDATED DISPLAY TEXT --- */}
          <span className="text-sm text-gray-400 font-medium px-2 text-center truncate" title={episodeDisplayText}>
            {episodeDisplayText}
          </span>
                    
          <button onClick={handleNextEpisode} disabled={isLastEpisode} className="flex-shrink-0 flex items-center gap-2 px-3 py-2 bg-gray-700 hover:bg-gray-600 disabled:bg-gray-800 disabled:text-gray-500 text-white rounded-lg text-sm font-medium transition-all duration-200 disabled:cursor-not-allowed">
            Next <FiChevronDown className="-rotate-90 text-sm" />
          </button>
        </div>
      )}
    </div>
  );
}